exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".imageHint-fd8f12a8{font-size:13px;color:#757575;margin-bottom:20px}.imageUploadWithNote-fc83905e{margin-bottom:8px}\n", ""]);

// Exports
exports.locals = {
	"imageHint": "imageHint-fd8f12a8",
	"imageUploadWithNote": "imageUploadWithNote-fc83905e"
};